__turbopack_context__.v({
  "className": "inter_19ea65c7-module__-K77_a__className",
});
